/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ColumnVisibilitySet } from './ColumnVisibilitySet';
import {
    ColumnVisibilitySetFromJSON,
    ColumnVisibilitySetFromJSONTyped,
    ColumnVisibilitySetToJSON,
} from './ColumnVisibilitySet';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';

/**
 * 
 * @export
 * @interface ColumnVisibilitySettings
 */
export interface ColumnVisibilitySettings {
    /**
     * 
     * @type {Command}
     * @memberof ColumnVisibilitySettings
     */
    applyCommand?: Command;
    /**
     * 
     * @type {boolean}
     * @memberof ColumnVisibilitySettings
     */
    canCreateSharedSettings?: boolean;
    /**
     * 
     * @type {Array<ColumnVisibilitySet>}
     * @memberof ColumnVisibilitySettings
     */
    availableColumnVisibilitySets: Array<ColumnVisibilitySet>;
    /**
     * 
     * @type {Command}
     * @memberof ColumnVisibilitySettings
     */
    saveNewCommand?: Command;
}

/**
 * Check if a given object implements the ColumnVisibilitySettings interface.
 */
export function instanceOfColumnVisibilitySettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "availableColumnVisibilitySets" in value;

    return isInstance;
}

export function ColumnVisibilitySettingsFromJSON(json: any): ColumnVisibilitySettings {
    return ColumnVisibilitySettingsFromJSONTyped(json, false);
}

export function ColumnVisibilitySettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColumnVisibilitySettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'applyCommand': !exists(json, 'applyCommand') ? undefined : CommandFromJSON(json['applyCommand']),
        'canCreateSharedSettings': !exists(json, 'canCreateSharedSettings') ? undefined : json['canCreateSharedSettings'],
        'availableColumnVisibilitySets': ((json['availableColumnVisibilitySets'] as Array<any>).map(ColumnVisibilitySetFromJSON)),
        'saveNewCommand': !exists(json, 'saveNewCommand') ? undefined : CommandFromJSON(json['saveNewCommand']),
    };
}

export function ColumnVisibilitySettingsToJSON(value?: ColumnVisibilitySettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'applyCommand': CommandToJSON(value.applyCommand),
        'canCreateSharedSettings': value.canCreateSharedSettings,
        'availableColumnVisibilitySets': ((value.availableColumnVisibilitySets as Array<any>).map(ColumnVisibilitySetToJSON)),
        'saveNewCommand': CommandToJSON(value.saveNewCommand),
    };
}

